import { render, staticRenderFns } from "./SchoologyStep1.vue?vue&type=template&id=6b753b52&"
import script from "./SchoologyStep1.vue?vue&type=script&lang=js&"
export * from "./SchoologyStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports